<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="管理员名称：" prop="nickName">
            <el-input style="width: 424px;" v-model="ruleForm.nickName" placeholder="请输入管理员名称"></el-input>
          </el-form-item>
          <el-form-item label="登录账号：" prop="userName">
            <el-input style="width: 424px;" v-model="ruleForm.userName" placeholder="请输入等级名称"></el-input>
            <div class="mt-warm-txt"><span>登录后台账号，英文或数字，不超过16位</span></div>
          </el-form-item>
          <el-form-item v-if="dataId == ''" label="登录密码：" prop="userPassword">
            <el-input style="width: 424px;" v-model="ruleForm.userPassword" placeholder="请输入等级名称"></el-input>
            <div class="mt-warm-txt"><span>英文或数字，不少于6位</span></div>
          </el-form-item>
          <el-form-item label="角色（权限）：" prop="roleIdList">
            <el-select style="width: 424px;" v-model="ruleForm.roleIdList" multiple collapse-tags placeholder="请选择">
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveManagementUser, updateManagementUser, fetchManagementUserDetailById, queryAllRoleList } from '@/api/setting'
export default {
  name: 'ManagerAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      dataId: this.$route.query.dataId,
      roleList:[],
      ruleForm: {
        nickName: '',
        userName: '',
        userPassword: '',
        roleIdList: [],
        status: false
      },
      rules: {
        nickName: [
          { required: true, message: '请输入轮播图名称', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请选择跳转类型', trigger: 'blur' }
        ],
        userPassword: [
          { required: true, message: '请选择跳转类型', trigger: 'blur' }
        ],
        roleIdList: [
          { required: true, message: '请输入小程序appid', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.roleInfoFun();
    if (this.$route.query.dataId != '') {
      let that = this
      fetchManagementUserDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.nickName = data.nickName
          that.ruleForm.userName = data.userName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.userPassword = data.userPassword
          that.ruleForm.roleIdList = data.roleIdList
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 角色数据
    roleInfoFun(){
      var that = this;
      queryAllRoleList().then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          that.roleList = data;
        }
      });
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let nickName = that.ruleForm.nickName
      let userName = that.ruleForm.userName
      let userPassword = that.ruleForm.userPassword
      var roleIdList = that.ruleForm.roleIdList
      let status = that.ruleForm.status ? 1 : 0
      if (nickName === '') {
        this.$message.error('请输入管理员名称')
        return false
      }
      if (userName === '') {
        this.$message.error('请输入等级名称')
        return false
      }
      if (userPassword === '') {
        this.$message.error('请输入等级名称')
        return false
      }
      if (roleIdList.length === 0) {
        this.$message.error('请选择角色（权限）')
        return false
      }
      let passData = {
        nickName: nickName, status: status, userName: userName, userPassword: userPassword, roleIdList: roleIdList
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateManagementUser(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveManagementUser(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/ManagerAdd.vue